import { motion } from "framer-motion";
import React, { useContext, useRef } from "react";
import { EaseContext, WidthContext } from "../App";
import { State } from "./KlimaContent";

interface Props {
  setCurrentState: (state: State) => void;
  setCurrentQuesNum: (num: number) => void;
}

export const ResultContentExit: React.FC<Props> = (props) => {
  const { setCurrentState, setCurrentQuesNum } = props;
  const divRef = useRef(null);

  const handleClick = () => {
    setCurrentState("welcome");
    setCurrentQuesNum(0);
  };
  const score = 9999;

  const width = useContext(WidthContext);
  const ease = useContext(EaseContext);

  return (
    <motion.div
      ref={divRef}
      initial={{ opacity: 1, x: 0 }} // 初期状態
      animate={{ opacity: 0, x: -width }} // マウント時
      exit={{ x: 20 }} // アンマウント時
      transition={{
        duration: 0.5,
        ease: ease,
      }}
      className="w-full rounded-xl shadow-xl my-8 md:px-6 py-10 bg-slate-50 px-2 absolute -z-10 top-0"
    >
      <h2 className="text-center text-3xl font-semibold">結果発表</h2>
      <div className="flex justify-center pt-4 pb-4">
        <img src="/images/result.png" alt="welcome" className="h-44" />
      </div>
      <div>
        <div className="text-semibold text-center font-semibold">
          <div className="text-md">あなたの年間CO2排出量</div>
          <div className="text-5xl mt-1 flex items-end justify-center">
            {score}
            <span className="ml-1 text-lg">kg-co2</span>
          </div>
        </div>
      </div>
      <h2 className="text-center text-xl font-semibold mt-10">
        みんなのCO2排出量
      </h2>
      <div className="flex flex-col items-center mt-4 gap-2">
        <div className="flex">
          <div className="font-semibold w-24 text-right">回答者の平均</div>
          <div className="ml-4">
            9999<span className="ml-0.5 text-sm">kg-co2</span>
          </div>
        </div>
        <div className="flex">
          <div className="font-semibold w-24 text-right">日本の平均</div>
          <div className="ml-4">
            9999<span className="ml-0.5 text-sm">kg-co2</span>
          </div>
        </div>
      </div>
      <div className="flex justify-center mt-12 mb-3 px-4">
        <button className="btn w-full" onClick={handleClick}>
          もう一回あそぶ
        </button>
      </div>
    </motion.div>
  );
};
